import React from 'react';
import { Box, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getMusicStyleLabel, MUSIC_STYLES } from '../../constants/musicStyles';

type MusicStyleSelectorProps = {
  selected: string[];
  onChange: (selected: string[]) => void;
  disabled?: boolean;
};

const MusicStyleSelector: React.FC<MusicStyleSelectorProps> = ({
  selected,
  onChange,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const toggleStyle = (tag: string) => {
    if (disabled) return;

    if (selected.includes(tag)) {
      onChange(selected.filter((value) => value !== tag));
      return;
    }

    onChange([...selected, tag]);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1,
        justifyContent: 'center',
        mt: 1,
      }}
      role="group"
      aria-label="Music styles"
    >
      {MUSIC_STYLES.map((style) => {
        const isSelected = selected.includes(style.tag);

        return (
          <Chip
            key={style.tag}
            label={getMusicStyleLabel(style.tag, t)}
            clickable={!disabled}
            disabled={disabled}
            color={isSelected ? 'primary' : 'default'}
            variant={isSelected ? 'filled' : 'outlined'}
            onClick={() => toggleStyle(style.tag)}
            sx={{
              fontWeight: isSelected ? 600 : 400,
              borderWidth: 2,
              '& .MuiChip-label': {
                px: 1.25,
              },
            }}
          />
        );
      })}
    </Box>
  );
};

export default MusicStyleSelector;
